<template>
  <main>
    <article class="row left-align">
      <section class="col s12">
        <router-link to="/tickeradmin/listoptions" class="blue-grey-text text-darken-4 strong">Security Master</router-link>
        >
        <span>Add Option</span>
      </section>
    </article>
    <h4>Add Option</h4>
    <article class="row">
      <look-ahead id="usm-add-option-instrument-lookahead"
                  name="Instrument"
                  size="s6"
                  :picks="instrumentPicks"
                  @searched="searchInstruments"
                  @picked="handleInstrumentPick($event)"
                  watermark="MSFT or Microsoft"
                  :disabled="!$auth.hasRoles('admin', 'contractor-usm-admin')"
      />
      <autocomplete
        v-if="exchanges.length"
        id="usm-add-option-exchange-autocomplete"
        name="Exchange"
        size="s4"
        :picks="exchangePicks"
        @picked="payload.exchange_id = Number($event.slice(1, $event.indexOf(' ')))"
        :disabled="!$auth.hasRoles('admin', 'contractor-usm-admin')"
      />
      <section class="input-field col s2">
        <input type="number"
               placeholder="123"
               class="validate"
               pattern="^[0-9]*$"
               v-model="payload.apx_security_id"
               :disabled="!$auth.hasRoles('admin', 'contractor-usm-admin')"
        >
        <label class="active">
          APX Security ID
        </label>
        <span class="helper-text left grey-text text-lighten-2">Optional</span>
      </section>
    </article>
    <article class="row">
      <section class="input-field col s3 switch">
        <label class="active">Option Type</label>
        <p>
          <span class="radio">
            <label>
              <input type="radio" v-model="payload.is_put" :value="true">
              <span>Put</span>
            </label>
          </span>
          <span class="radio">
            <label>
              <input type="radio" v-model="payload.is_put" :value="false">
              <span>Call</span>
            </label>
          </span>
        </p>
      </section>
      <section class="input-field col s2">
        <input type="text"
               placeholder="3.14"
               class="validate"
               pattern="^[0-9]+\.?[0-9]*$"
               v-model="payload.strike_price"
               :disabled="!$auth.hasRoles('admin', 'contractor-usm-admin')"
        >
        <label class="active">$trike Price</label>
      </section>
      <section class="input-field col s3">
        <input id="ticker-admin-add-option-expiration-date"
               type="text"
               class="datepicker validate"
               pattern="^[0-9]{4}-[0-9]{2}-[0-9]{2}$"
               v-model="payload.expiration_date"
               @change="payload.expiration_date = $event.target.value"
               :disabled="!$auth.hasRoles('admin', 'contractor-usm-admin')"
        >
        <label class="active">Expiration Date</label>
      </section>
      <section class="input-field col s4">
        <input type="text"
               placeholder="AAPL110319C00195000"
               class="validate"
               v-model="payload.symbol"
               pattern="^[A-Z]+[0-9]{6}[CP][0-9]{8}$"
               :disabled="!$auth.hasRoles('admin', 'contractor-usm-admin')"
        >
        <label class="active">OSI Symbol</label>
      </section>
    </article>
    <article class="row">
      <section class="col s9" />
      <section class="col s3">
        <input class="btn waves-effect waves-light teal accent-4 right"
               type="submit"
               value="Submit"
               @click.prevent="saveOption"
               :disabled="!payload.underlying_instrument_parent_id || !payload.exchange_id || !Number(payload.strike_price) || !payload.expiration_date || payload.is_put === null"
        >
      </section>
    </article>
  </main>
</template>

<script>
import axios from 'axios';
import LookAhead from '@/components/LookAhead.vue';
import Autocomplete from '@/components/Autocomplete.vue';

const defaultPayload = {
  underlying_instrument_parent_id: 0,
  exchange_id: 0,
  apx_security_id: null,
  strike_price: 0.0,
  is_put: null,
  expiration_date: '',
  symbol: '',
};

export default {
  name: 'TickerAdminAddOption',
  components: { LookAhead, Autocomplete },
  props: {},
  data() {
    return {
      exchanges: [],
      instruments: [],
      payload: { ...defaultPayload },
      instrumentSymbol: '',
    };
  },
  computed: {
    instrumentPicks() {
      return this.instruments.map(instrument => `#${instrument.InstrumentId} ${instrument.Exchange}:${instrument.Symbol} ${instrument.Name}`);
    },
    exchangePicks() {
      return this.exchanges.map(exchange => `#${exchange.id} ${exchange.symbol} ${exchange.name}`);
    },
    computedOsiSymbol() {
      function formatDate(dateString) {
        const date = new Date(dateString);
        date.setMinutes(date.getMinutes() + date.getTimezoneOffset() + 1);
        return `${String(date.getFullYear() - 2000).padStart(2, '0')}${String(date.getMonth() + 1).padStart(2, '0')}${String(date.getDate()).padStart(2, '0')}`;
      }
      function formatStrikePrice(strikePrice) {
        return String(strikePrice * 1000).padStart(8, '0');
      }
      if (this.instrumentSymbol && this.payload.expiration_date && this.payload.strike_price) {
        return `${this.instrumentSymbol}${formatDate(this.payload.expiration_date)}${this.payload.is_put ? 'P' : 'C'}${formatStrikePrice(this.payload.strike_price)}`;
      }
      return '';
    },
  },
  watch: {
    computedOsiSymbol() {
      this.payload.symbol = this.computedOsiSymbol;
    },
  },
  methods: {
    initSelect() {
      this.materialize.FormSelect.init(document.querySelectorAll('select'), {});
    },
    initDatepicker() {
      this.materialize.Datepicker.init(document.getElementById('ticker-admin-add-option-expiration-date'), {
        autoClose: false,
        format: 'yyyy-mm-dd',
        disableWeekends: true,
        showDaysInNextAndPreviousMonths: true,
        showClearBtn: true,
        onSelect() {},
      });
    },
    async fetchExchanges() {
      const { data } = await axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/instruments/exchanges/`);
      this.exchanges = data;
    },
    async searchInstruments(query) {
      if (query) {
        const { data } = await axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/quotes/instruments/search/?q=${query}`);
        this.instruments = data.SearchResults;
      }
    },
    async saveOption() {
      try {
        const response = await axios.post(`${this.$store.getters.VUE_APP_APING_URL}/insights/instruments/option/`, this.payload);
        const option = response.data;

        this.toastWithLink(
          `Created Option: ${option.symbol} (Instrument ID: ${option.id})`,
          'View Details',
          `/tickeradmin/editoption?option_id=${option.id}`,
          'green'
        );

        this.payload = { ...defaultPayload };
        document.getElementById('usm-add-option-instrument-lookahead').value = '';
        document.getElementById('ticker-admin-add-option-expiration-date').value = '';
        document.getElementById('usm-add-option-exchange-autocomplete').value = '';
      } catch (exception) {
        this.toast('Something went wrong. Please contact #investing-tech-help.', 'pink');
      }
    },
    handleInstrumentPick(event) {
      this.payload.underlying_instrument_parent_id = Number(event.slice(1, event.indexOf(' ')));
      this.instrumentSymbol = event.slice(event.indexOf(':') + 1, event.indexOf(' ', (event.indexOf(':'))));
    },
  },
  async mounted() {
    this.initDatepicker();
    this.initSelect();
    await this.fetchExchanges();
  },
};
</script>

<style lang="scss" scoped>
@import '@/main.scss';

.switch label input[type="checkbox"]:checked + .lever::after {
  background-color: #F1F1F1;
}

.radio {
  margin: 0px 5px 0px 5px;
}
</style>
